import { createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import {
	SET_ERROR
} from './actions';

const initialState = {
	pageData: {
		csrf_token: null,
		acct_id: null,
		funnel_page_id: null,
		hook_status: null,
		preview: false,
		internaltest: ''
	},
	fv: null,
	contactFields: {
		email: '',
		country_code: '',
		mobile: ''
	},
	optionFields: [],
	lineUserData: {
		userId: '',
		nickname: '',
		email: '',
		follow: false
	},
	userData: {},
	curStep: 1,
	nextStep: 2,
	cbModalData: {
		open: false,
		checkedValues: [],
		form_component: {}
	},
	cbModalOtherData: '',
	cbFieldData: {},
	cbFieldOtherData: {},
	error: null,
	jumpHistory: []
};

const drawerReducer = (state = initialState, action) => {
	switch (action.type) {
		case 'SET_PAGE_DATA':
			//console.log("UPDATE_REMINDER_DATA triggered, payload", action.payload);
			return {
				...state,
				pageData: action.payload
			};
		case 'SET_LINE_USER_DATA':
			//console.log("UPDATE_REMINDER_DATA triggered, payload", action.payload);
			return {
				...state,
				lineUserData: {
					...state.lineUserData,
					[action.payload.field]: action.payload.value
				}
			};
		case 'SET_CONTACT_FIELD':
			//console.log("UPDATE_REMINDER_DATA triggered, payload", action.payload);
			return {
				...state,
				contactFields: {
					...state.contactFields,
					[action.payload.field]: action.payload.value
				}
			};
		case 'SET_OPTION_FIELDS':
			//console.log("SET_OPTION_FIELDS triggered, payload", action.payload);
			return {
				...state,
				optionFields: action.payload
			};
		case 'SET_USER_DATA':
			//console.log("UPDATE_REMINDER_DATA triggered, payload", action.payload);
			return {
				...state,
				userData: action.payload
			};
		case 'SET_FV':
			//console.log("SET_FV triggered, payload", action.payload);
			return {
				...state,
				fv: action.payload
			};
		case 'SET_CUR_STEP':
			return {
				...state,
				curStep: action.payload
			};
		case 'SET_NEXT_STEP':
			console.log(`SET_NEXT_STEP triggered, payload`, action.payload);
			return {
				...state,
				nextStep: action.payload
			};
		case 'SET_CBMODAL_DATA':
			return {
				...state,
				cbModalData: action.payload
			};
		case 'SET_CBMODAL_OTHER_DATA':
			return {
				...state,
				cbModalOtherData: action.payload
			};
		case 'SET_CBFIELD_DATA':
			return {
				...state,
				cbFieldData: action.payload
			};
		case 'SET_CBFIELD_OTHER_DATA':
			//console.log("SET_CBFIELD_OTHER_DATA triggered, payload", action.payload);
			return {
				...state,
				cbFieldOtherData: action.payload
			};
		case 'SET_JUMP_HISTORY':
			return {
				...state,
				jumpHistory: action.payload
			};
		case SET_ERROR:
			return { ...state, error: action.payload };
		default:
			return state;
	}
};

const store = createStore(drawerReducer, applyMiddleware(thunk));

export default store;